import { render, staticRenderFns } from "./WarehouseTransitTypes.vue?vue&type=template&id=ba5060d2&"
import script from "./WarehouseTransitTypes.vue?vue&type=script&lang=ts&"
export * from "./WarehouseTransitTypes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports